var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DeviceLayout',[_c('PcPage',_vm._b({attrs:{"slot":"pc"},slot:"pc"},'PcPage',_vm.landingProps,false)),_c('MobilePage',_vm._b({attrs:{"slot":"mobile"},slot:"mobile"},'MobilePage',_vm.landingProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }